module.exports = __webpack_public_path__ + "img/client.6a4141cc.svg";